import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Modal, Form, Row, Col, Alert } from 'react-bootstrap';
import { getAuthHeaders } from '../../utils/auth';
const UpdateBetModal = ({ show, onHide, bet, onBetUpdated }) => {
    const [formData, setFormData] = useState({
        actualResult: bet?.actualResult || '',
        actualPayout: bet?.actualPayout || '',
        notes: bet?.notes || '',
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: name === 'actualPayout' ? (value ? parseFloat(value) : '') : value
        }));
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            const response = await fetch(`/api/user-bets/${bet.id}`, {
                method: 'PATCH',
                headers: Object.assign({ 'Content-Type': 'application/json' }, getAuthHeaders()),
                body: JSON.stringify({
                    actualResult: formData.actualResult || undefined,
                    actualPayout: formData.actualPayout || undefined,
                    notes: formData.notes,
                    status: formData.actualResult ? 'completed' : 'pending'
                })
            });
            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.message || 'Failed to update bet');
            }
            onBetUpdated();
            onHide();
        }
        catch (err) {
            setError(err.message || 'Failed to update bet');
        }
        finally {
            setLoading(false);
        }
    };
    if (!bet)
        return null;
    const calculatePotentialPayout = () => {
        if (!bet.odds || !bet.betAmount)
            return null;
        const odds = parseFloat(bet.odds);
        const amount = bet.betAmount;
        if (odds > 0) {
            return amount + (amount * (odds / 100));
        }
        else {
            return amount + (amount * (100 / Math.abs(odds)));
        }
    };
    const potentialPayout = calculatePotentialPayout();
    return (_jsxs(Modal, { show: show, onHide: onHide, children: [_jsx(Modal.Header, { closeButton: true, children: _jsx(Modal.Title, { children: "Update Bet Result" }) }), _jsxs(Form, { onSubmit: handleSubmit, children: [_jsxs(Modal.Body, { children: [error && _jsx(Alert, { variant: "danger", children: error }), _jsxs("div", { className: "mb-3 p-3 bg-light rounded", children: [_jsxs("h6", { children: [bet.awayTeam, " @ ", bet.homeTeam] }), _jsxs("p", { className: "mb-1", children: [_jsx("strong", { children: "Bet:" }), " ", bet.teamToCover, " ", bet.spread !== 0 && `${bet.spread > 0 ? '+' : ''}${bet.spread}`] }), _jsxs("p", { className: "mb-1", children: [_jsx("strong", { children: "Amount:" }), " $", bet.betAmount.toFixed(2)] }), bet.odds && (_jsxs("p", { className: "mb-1", children: [_jsx("strong", { children: "Odds:" }), " ", bet.odds, potentialPayout && ` (Potential payout: $${potentialPayout.toFixed(2)})`] }))] }), _jsxs(Row, { children: [_jsx(Col, { md: 6, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "Result" }), _jsxs(Form.Select, { name: "actualResult", value: formData.actualResult, onChange: handleChange, required: true, children: [_jsx("option", { value: "", children: "Select result" }), _jsx("option", { value: "won", children: "Won" }), _jsx("option", { value: "lost", children: "Lost" }), _jsx("option", { value: "push", children: "Push" })] })] }) }), _jsx(Col, { md: 6, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "Actual Payout" }), _jsx(Form.Control, { type: "number", step: "0.01", name: "actualPayout", value: formData.actualPayout, onChange: handleChange, placeholder: formData.actualResult === 'won' && potentialPayout ? potentialPayout.toFixed(2) : '0.00' }), _jsxs(Form.Text, { className: "text-muted", children: [formData.actualResult === 'won' && 'Enter total amount received (stake + winnings)', formData.actualResult === 'lost' && 'Usually 0 for a loss', formData.actualResult === 'push' && 'Usually your stake amount for a push'] })] }) })] }), _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "Notes" }), _jsx(Form.Control, { as: "textarea", rows: 2, name: "notes", value: formData.notes, onChange: handleChange, placeholder: "Any additional notes..." })] })] }), _jsxs(Modal.Footer, { children: [_jsx("button", { type: "button", className: "btn-touch btn-touch-secondary me-3", onClick: onHide, children: "Cancel" }), _jsx("button", { type: "submit", className: `btn-touch btn-touch-primary ${loading ? 'loading' : ''}`, disabled: loading, children: loading ? (_jsxs(_Fragment, { children: [_jsx("span", { className: "spinner-border spinner-border-sm me-2", role: "status" }), "Updating..."] })) : (_jsxs(_Fragment, { children: [_jsx("i", { className: "fas fa-save me-2" }), "Update Bet"] })) })] })] })] }));
};
export default UpdateBetModal;
